import axios from "axios";

export const getAvailableSlide = data => {
  const requestUrl = `/data/slides-list`;
  let {
    pageSize,
    paginationPage,
    labels,
    indicators,
    status,
    uen,
    backOffice,
    isPublic,
    operator,
    filterStatus,
    newSlideIds
  } = data;
  const fields = [];
  let filter = [];
  let sort = [];

  if (labels && labels.length > 0) {
    filter.push({
      property: "labels",
      value: labels,
      operator: "like"
    });
  }
  if (newSlideIds && newSlideIds.length > 0) {
    filter.push({
      property: "id",
      value: newSlideIds,
      operator: "in"
    });
  }
  if (backOffice) {
    filter.push({
      property: "status",
      value: "STANDARD",
      operator: "eq"
    });
  } else if (status && status.length > 0) {
    filter.push({
      property: "status",
      value: status.toString(),
      operator: "eq"
    });
  }
  if (indicators && indicators.length > 0) {
    filter.push({
      property: "indicators",
      value: indicators[0].toString().slice(1),
      operator: "like"
    });
  }
  if (isPublic && operator) {
    filter.push({
      property: "isPublic",
      value: isPublic.toString(),
      operator: operator.toString()
    });
  }
  sort.push({
    property: "createdAt",
    dir: "desc"
  });

  let params = {
    fields: fields.join(","),
    limit: pageSize || 12,
    start: !paginationPage ? 0 : (paginationPage - 1) * pageSize,
    uen: uen,
    filterStatus: filterStatus
  };
  params.filter = JSON.stringify(filter).replace(
    /SPECIAL_CHAR_TO_REPLACE/g,
    "\\"
  );
  params.sort = JSON.stringify(sort);

  return axios.get(requestUrl, {
    params
  });
};

export const getIndicatorsSuggestions = ({
  organizationUen,
  lng = "fr",
  searchWord = null
}) => {
  const requestUrl = `/data/indicator/formula-supported-vars`;
  const fields = ["*"];
  let filter = [];

  if (null !== searchWord) {
    filter = [
      {
        property: "label",
        value: searchWord,
        operator: "like"
      }
    ];
  }
  return axios.get(requestUrl, {
    params: {
      organizationUen,
      fields: fields.join(","),
      filter: JSON.stringify(filter)
    }
  });
};

export const deleteSlideApi = ({ id }) => {
  const requestUrl = `/data/delete-slide`;

  let formData = new FormData();
  formData.append("id", id);

  return axios.post(requestUrl, formData);
};
export const duplicateSlide = ({ uen, id, status, isBackOffice }) => {
  const requestUrl = `/data/duplicate-slide`;

  let formData = new FormData();
  formData.append("uen", uen);
  formData.append("id", id);
  formData.append("status", status);
  formData.append("isBackOffice", isBackOffice);

  return axios.post(requestUrl, formData);
};

export const updateSlidePrivacyApi = ({ id, isEditable }) => {
  const requestUrl = `/data/update-slide-privacy`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("isEditable", isEditable);

  return axios.post(requestUrl, formData);
};

export const updateSlideStateApi = ({ id, uen }) => {
  const requestUrl = `/data/update-slide-state`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("uen", uen);
  return axios.post(requestUrl, formData);
};

export const setSlidePrivate = ({ id }) => {
  const requestUrl = `/data/set-slide-private`;

  let formData = new FormData();
  formData.append("id", id);

  return axios.post(requestUrl, formData);
};

export const useSharedSlideApi = ({ id, uen }) => {
  const requestUrl = `/data/use-shared-slide`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("uen", uen);
  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/slideList.js